













import mixins from 'vue-typed-mixins';
import { TextBlockOptions } from '.';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => TextBlockOptions,
    },
  },
  mounted() {
    // set  values to defaults
    this.$emit('input', {
      ...this.value,
      text:
        this.value.text !== undefined && !Array.isArray(this.value.text)
          ? this.value.text
          : { en: undefined, fr: undefined },
    });
  },
});
